import { generateUtilityClasses } from '../../utils';

export const dataTableSkeletonClasses = generateUtilityClasses('DataTableSkeleton', [
  'root',
  'actionBar',
  'table',
]);
